import type { IconProps } from './img'

export function ClipboardIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FileDownloadOutlineIcon(props: IconProps) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0002 12.5V15H5.00016V12.5H3.3335V15C3.3335 15.9167 4.0835 16.6667 5.00016 16.6667H15.0002C15.9168 16.6667 16.6668 15.9167 16.6668 15V12.5H15.0002ZM14.1668 9.16671L12.9918 7.99171L10.8335 10.1417V3.33337H9.16683V10.1417L7.0085 7.99171L5.8335 9.16671L10.0002 13.3334L14.1668 9.16671Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FileDownloadIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.825 7.91667H12.5V3.75001C12.5 3.29167 12.125 2.91667 11.6666 2.91667H8.33329C7.87496 2.91667 7.49996 3.29167 7.49996 3.75001V7.91667H6.17496C5.43329 7.91667 5.05829 8.81667 5.58329 9.34167L9.40829 13.1667C9.73329 13.4917 10.2583 13.4917 10.5833 13.1667L14.4083 9.34167C14.9333 8.81667 14.5666 7.91667 13.825 7.91667ZM4.16663 16.25C4.16663 16.7083 4.54163 17.0833 4.99996 17.0833H15C15.4583 17.0833 15.8333 16.7083 15.8333 16.25C15.8333 15.7917 15.4583 15.4167 15 15.4167H4.99996C4.54163 15.4167 4.16663 15.7917 4.16663 16.25Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function File04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1.26946V5.4C11 5.96005 11 6.24008 11.109 6.45399C11.2049 6.64215 11.3578 6.79513 11.546
6.89101C11.7599 7 12.0399 7 12.6 7H16.7305M17 8.98822V16.2C17 17.8802 17 18.7202 16.673
19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H5.8C4.11984 21
3.27976 21 2.63803 20.673C2.07354 20.3854 1.6146 19.9265 1.32698 19.362C1 18.7202 1 17.8802 1
16.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1
4.11984 1 5.8 1H9.01178C9.74555 1 10.1124 1 10.4577 1.08289C10.7638 1.15638 11.0564 1.27759 11.3249
1.44208C11.6276 1.6276 11.887 1.88703 12.4059 2.40589L15.5941 5.59411C16.113 6.11297 16.3724 6.3724
16.5579 6.67515C16.7224 6.94356 16.8436 7.2362 16.9171 7.5423C17 7.88757 17 8.25445 17 8.98822Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
